import { EquipmentTypeValues, VehicleEquipment } from './VehicleEquipment';
import { VehicleHero } from './VehicleHero';
import { VehicleVillain } from './VehicleVillain';

export abstract class VehicleEquipmentCapture extends VehicleEquipment {
  protected vehicle: VehicleHero;
  protected abstract fireYPos: number;
  protected abstract fireDistance: number;
  protected abstract prefireTime: number;
  protected abstract beforeHitTime: number;
  protected abstract fireTime: number;

  constructor(scene: Phaser.Scene, equipmentType: EquipmentTypeValues, vehicle: VehicleHero) {
    super(scene, equipmentType);

    this.vehicle = vehicle;
  }

  get PrefireTime() {
    return this.prefireTime;
  }

  get BeforeHitTime() {
    return this.beforeHitTime;
  }

  get FireTime() {
    return this.fireTime;
  }

  public abstract beforeMoveIntoPosition(): void;
  public abstract afterMoveIntoPosition(): void;
  public abstract beforeCaptureFire(): void;
  public abstract triggerCaptureFire(): void;
  public abstract beforeCaptureHit(): void;
  public abstract onCaptureHit(): void;
  public abstract onPull(): void;
}
